import React from "react";
import { Link } from "gatsby";
import useFooterData from "@staticQueries/footerQuery";
import { Container } from "@components/ui";
import LinkGroup, { KontentLinkGroup } from "./LinkGroup";
import MasterDisclaimer from "./MasterDisclaimer";
import LeadFormController from "@components/leadForm/LeadFormController";

interface FooterDataTypes {
  logo: { value: { url: string }[] };
  link_groups: { value: KontentLinkGroup[] };
}

const Footer = ({ useLeadForm }: any) => {
  const data: FooterDataTypes = useFooterData();
  return (
    <footer className="w-full bg-primary-dark">
      {useLeadForm && (
        <div className="relative">
          <a className="absolute top-[-120px]" id="leadform"></a>
          <div className={` bg-primary-dark pb-[40px] pt-[30px]`}>
            <Container>
              <LeadFormController />
            </Container>
          </div>
          <div className="h-[5px] w-full bg-white"></div>
        </div>
      )}
      <Container className="flex flex-col gap-y-7 py-10 md:py-14">
        <Link to="/">
          <img
            src={data.logo.value[0].url}
            alt="CheckSmart Logo"
            width={186}
            height={30}
          />
        </Link>
        <div className="flex flex-col justify-between gap-y-6 md:flex-row">
          {data.link_groups.value.map((group, idx: number) => {
            // Rendering LinkGroup with a non link title if that key value is not blank
            if (group.elements.non_link_title.value != "") {
              return (
                <LinkGroup
                  nonLinkTitle={group.elements.non_link_title.value}
                  subLinks={group.elements.sub_links.value}
                  key={idx}
                />
              );
              // Otherwise render LinkGroup with a title link
            } else {
              return (
                <LinkGroup
                  titleLink={group.elements.title_link.value[0]}
                  subLinks={group.elements.sub_links.value}
                  key={idx}
                />
              );
            }
          })}
        </div>
      </Container>
      <MasterDisclaimer />
    </footer>
  );
};

export default Footer;
